import React from 'react';

const QuestionBubble = ({
  height = '1em',
  backgroundColor = '#FF697C',
  foregroundColor = '#fff',
}) => (
  <svg height={height} viewBox="0 0 57 57" xmlns="http://www.w3.org/2000/svg">
    <g id="Page-1" fill="none" fillRule="evenodd">
      <g id="6-winners-copy" transform="translate(-568 -216)">
        <g id="Group-9" transform="translate(511 163)">
          <g id="Group-5" transform="translate(57 53)">
            <g id="Group-13" fill={backgroundColor}>
              <circle id="Oval-2" cx="28.5" cy="28.5" r="28.5" />
            </g>
            <g
              id="36601"
              transform="translate(20 16)"
              fill={foregroundColor}
              fillRule="nonzero"
            >
              <path
                d="M8.15102284,0 C12.6100392,0 17,1.99151732 17,6.75505453 C17,11.147873 11.8093235,12.8372345 10.6945694,14.4245488 C9.85768176,15.6052682 10.1371924,17.2643345 7.83780654,17.2643345 C6.33995849,17.2643345 5.60829836,16.0828178 5.60829836,15.0017539 C5.60829836,10.9788571 11.7032739,10.0684036 11.7032739,6.75585178 C11.7032739,4.9325531 10.4520529,3.85148925 8.3606558,3.85148925 C3.90163944,3.85148925 5.64282614,8.30968174 2.26568027,8.30968174 C1.04652075,8.30968174 1.29917244e-07,7.60013394 1.29917244e-07,6.24960138 C-0.00082196012,2.93625231 3.89999526,0 8.15102284,0 Z M7.97756185,19.4575547 C9.54282128,19.4575547 10.8343247,20.7060399 10.8343247,22.2287773 C10.8343247,23.7515148 9.54528755,25 7.97756185,25 C6.40983615,25 5.11997688,23.7531093 5.11997688,22.2287773 C5.11997688,20.7068372 6.40983615,19.4575547 7.97756185,19.4575547 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default QuestionBubble;
